<template>
  <v-main class="viewer">
    <div
      ref="appContainer"
      :class="
        this.$vuetify.breakpoint.name === 'sm' ||
        this.$vuetify.breakpoint.name === 'xs'
          ? 'appContainer-mobile'
          : 'appContainer'
      "
      style="overflow-x: hidden"
      @scroll.passive="onScroll"
    >
      <router-view class="routerView" />
      <v-btn
        class="btnScrollTop"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
    <dashboard-core-footer class="footer hidden-sm-and-down" />
    <network-error />
    <document-viewer />
  </v-main>
</template>

<script>
import { networkError, documentViewer } from "@/widget";

export default {
  name: "DashboardCoreView",
  components: {
    networkError,
    documentViewer,
    DashboardCoreFooter: () => import("./Footer"),
  },
  data: () => ({
    fab: false,
  }),
  computed: {
    scrollTop() {
      return this.$globalHandler.scroll.toTop;
    },
  },
  watch: {
    scrollTop(scroll) {
      if (scroll) this.$refs.appContainer.scrollTop = 0;
      this.$globalHandler.scroll.toTop = false;
    },
  },
  methods: {
    onScroll(e) {
      this.$nextTick(() => {
        if (typeof window === "undefined") return;
        const top =
          window.pageYOffset || this.$refs.appContainer.scrollTop || 0;
        this.fab = top > 20;
      });
    },
    toTop() {
      this.$nextTick(() => {
        this.$refs.appContainer.scrollTop = 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.appContainer {
  overflow-y: auto;
  height: calc(100vh - 90px);
}

.appContainer-mobile {
  overflow-y: auto;
  height: calc(100vh - 75px);
}

.footer {
  height: 30px;
  padding: 0px 20px;
  background-color: white;
  position: absolute;
}
.btnScrollTop {
  bottom: 15px;
}

.viewer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.07;
  background: url("/API/public/portal/getImage/THEME/wallpaper");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
